import styled, { css, Scale, StyledComponent } from '@se-admin/falcon';

export const RfyWrapper: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    padding-top: 0;
    padding-bottom: 0;
  `;
});

export const VerticalWrappedSaleCard: StyledComponent<'div', {}, {}> = styled('div')(() => {
  return css`
    display: flex;
    flex-shrink: 0;
    vertical-align: top;
    white-space: normal;
    margin-left: ${Scale.s};
    margin-bottom: ${Scale.m};
    width: calc(100% - ${Scale.l});
  `;
});
